import { Button, DatePicker, FilePicker, Group, IconHelp, Modal } from "@veneer/core";
import { useCreateJustifications } from "../../hooks/justificationAbsences/useCreateJustifications";
import { useTranslation } from "react-i18next";
import SimpleMessageModalWithOpenClose from "../Modals/SimpleMessageModalWithOpenClose";
import { IPropsComponentesTab } from "../../models/dto/justificationAbsences/IJustificationAbsenceModelDto";

export default function TabCreateJustifications(props: IPropsComponentesTab) {
  const [t] = useTranslation("global");
  const {
    handleOnDateRangeChange,
    dateOutsideRange,
    onClickConsultInformation,
    startDate,
    endDate,
    handleOnClickUploadFile,
    handleOnClickExitFileUpload,
    buttonSaveAbsencesFileDisabled,
    openModalUploadFile,
    submitJustificationAbsencesFile,
    errorFilePicker,
    fileName,
    handleFileChange,
    onClearFilePicker,
    helperFilePicker,
    setOpenModalHelp,
    openModalHelp
  } = useCreateJustifications(props);

    return (
      <>
        <div className="justification-absences-buttons">
          <div className="justification-absences-buttons-left">
            <DatePicker
              format="ll"
              range
              onChange={handleOnDateRangeChange}
              startDate={startDate?.format('MM/DD/YYYY')}
              endDate={endDate?.format('MM/DD/YYYY')}
              startDatePlaceholder="MM/DD/YYYY"
              endDatePlaceholder="MM/DD/YYYY"
              startDateLabel={t("header.stardDate")}
              endDateLabel={t("header.endDate")}
              isOutsideRange={dateOutsideRange}
            />

            <Button
              style={{ margin: "10px" }} 
              disabled={!(startDate && endDate)}
              onClick={onClickConsultInformation}
            >
              {t("header.consultInformation")}
            </Button>

            <div className="tooltip">
              <span className="tooltiptext">
                {t("modal.titleHelper").replace(":", "")}
              </span>
              <Button
                style={{ margin: "5px" }}
                appearance="secondary"
                leadingIcon={<IconHelp />}
                onClick={() => setOpenModalHelp(true)}
              >
                {t("modal.titleHelper").replace(":", "")}
              </Button>
            </div>
          </div>

          <div 
            className="justification-absences-buttons-right"
          >
            <Button style={{ margin: "10px" }} onClick={handleOnClickUploadFile}>
              {t("header.uploadFile")}
            </Button>
          </div>
        </div>

        <div style={{ position: "relative" }}>
          <Modal
            align="center"
            closeButton
            id="modal-Create"
            show={openModalUploadFile}
            onClose={handleOnClickExitFileUpload}
            footer={
              <div className="buttonGroup">
                <Group>
                  <Button appearance="secondary" onClick={handleOnClickExitFileUpload}>
                    {t("header.closebutton")}
                  </Button>
                  <Button onClick={submitJustificationAbsencesFile} disabled={buttonSaveAbsencesFileDisabled}>
                    {t("header.sendButton")}
                  </Button>
                </Group>
              </div>
            }
            title={t("modal.uploadFileJustificationAbsences")}
          >
            <div>
              <h5>{t("header.uploadFile")}</h5>
              <FilePicker
                className="modalSellOutFile"
                id="selOut-file-picker"
                label={t("header.uploadFile")}
                accept=".xlsx"
                onChange={handleFileChange}
                onClear={onClearFilePicker}
                value={fileName}
                error={errorFilePicker}
                helperText={helperFilePicker}
                helperTextVisibility="visible"
              />
            </div>
          </Modal>
        </div>

        <div style={{ position: "relative" }}>
          <SimpleMessageModalWithOpenClose
            modalMessage={t("modal.descriptionModalHelpJustificationAbsences")}
            modalTitle={t("modal.titleHelper")}
            setOpenCloseModal={setOpenModalHelp}
            showModal={openModalHelp}
          />
        </div>
      </>
    );
  };